export const ALPHANUMERIC_REGEX = "^[a-zA-Z0-9\\s\\.,!_#&@=:;%~'\\$\\*\\+\\?\\-\\|\\[\\]{}()/^]*$"
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const USER_NAME_REGEX = "^[a-zA-Z0-9\\s\\.,!_#&@=:;%~\\'\\$\\*\\+\\?\\-\\|\\[\\]{}()]*$";
export const USER_ID_REGEX = "^[a-zA-Z0-9\\s\\._]*$";
export const ROLE_NAME_REGEX = "^[a-zA-Z0-9\\s\\.,!_#&@=:;%~\\'\\$\\*\\+\\?\\-\\|\\[\\]{}()]*$";
export const DIGIT_ONLY_REGEX = "^\\d*$";


export function alphanumericValidator(input) {
    if (!input.match(ALPHANUMERIC_REGEX)) {
        return "You have entered unsupported special characters";
    }

    return "";
}

export function customRegexValidator(input, regex) {
    if (!input.match(regex)) {
        return "You have entered unsupported special characters";
    }
    return "";
}

export function digitValidator(input) {
    if (!input.match(DIGIT_ONLY_REGEX)) {
        return "You have entered characters in a digit only field";
    }
    return "";
}

export function optionalEmailValidator(input) {
    if (input && !input.match(EMAIL_REGEX)) {
        return "You have entered an invalid email address";
    }

    return "";
}